import { useTranslation } from 'react-i18next';

export const useCookiesLabels = () => {
  const { t } = useTranslation('common');
  return {
    cookies: t('cookiepolicy.label.cookies'),
    functionalAndTechnical: t('cookiepolicy.label.functionalTe'),
    cookieSubgroup: t('cookiepolicy.label.cookieSubgroup'),
    lifespan: t('cookiepolicy.label.lifespan'),
    cookiesUsed: t('cookiepolicy.label.cookiesUsed'),
    description: t('cookiepolicy.label.description'),
  };
};
